import { InputDevice } from '@app/shared/settings/settings.state';

export class SetDefaultInput {
  public static readonly type = '[Settings] Set Default Input';

  constructor(public inputDevice: InputDevice) {
  }
}

export class SetDefaultDesktopInput {
  public static readonly type = '[Settings] Set Default Desktop Input';

  constructor(public inputDevice: InputDevice) {
  }
}
